import en from './en';
import es from './es';
import pt from './pt';

export const LOCALES = { es, pt, en };
